import { i18n } from '@/i18n'
import { isApiError, ShowType } from '@/services/http'
import { showToast } from '@/stores/toastStore'

/**
 * Presents an error according to the backend `showType`. Wired into React Query globally,
 * so pages normally do not call it themselves.
 */
export function notifyError(error: unknown): void {
  if (!isApiError(error)) {
    console.error(error)
    showToast(i18n.t('error.unknown'), 'error')
    return
  }
  if (error.isCanceled) {
    return
  }

  switch (error.showType) {
    case ShowType.Silent:
      return
    case ShowType.WarnMessage:
      showToast(error.message, 'warning')
      return
    case ShowType.Notification:
      showToast(error.message, 'info')
      return
    case ShowType.Redirect:
      // Mini apps have no login page: auth comes from Telegram init data, so the only
      // recovery is reopening the app to get fresh, signed init data.
      showToast(i18n.t('error.sessionExpired'), 'error')
      return
    default:
      showToast(error.message, 'error')
  }
}
